var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.7499C6.35 21.7499 1.75 17.1499 1.75 11.4999C1.75 5.84988 6.35 1.24988 12 1.24988C17.65 1.24988 22.25 5.84988 22.25 11.4999C22.25 17.1499 17.65 21.7499 12 21.7499ZM12 2.74988C7.17 2.74988 3.25 6.67988 3.25 11.4999C3.25 16.3199 7.17 20.2499 12 20.2499C16.83 20.2499 20.75 16.3199 20.75 11.4999C20.75 6.67988 16.83 2.74988 12 2.74988Z",
    fill: "#8E8E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5004 22.7498C22.3104 22.7498 22.1204 22.6798 21.9704 22.5298L19.9704 20.5298C19.6804 20.2398 19.6804 19.7598 19.9704 19.4698C20.2604 19.1798 20.7404 19.1798 21.0304 19.4698L23.0304 21.4698C23.3204 21.7598 23.3204 22.2398 23.0304 22.5298C22.8804 22.6798 22.6904 22.7498 22.5004 22.7498Z",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.33ed1c2fcca46bd0240b0b45d2cb7659.svg";
export { ForwardRef as ReactComponent };